export enum Environments {
  Localhost = 'localhost',
  Dev = 'dev',
  Uat = 'uat',
  Prod = 'prod',
}
